module.exports = __webpack_public_path__ + "img/time.8f6c1070.svg";